import { useEffect, useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
// import { all_routes } from '../router/all_routes';
// import Table from "../../core/common/dataTable/index";
// import AXIOSCONFIGMETHOD from '../../Axios/axiosConfigMethod';
// import { webServiceUrl } from '../../core/api_utils/webserviceUrl';
// import Loading from '../../core/common/custom-loading/Loading';
// import SearchSelect from '../../core/common/search-select/searchSelect';
// import CommonSelect2 from '../../core/common/commonSelect2';
import { all_routes } from '../../router/all_routes';
import Table from '../../../core/common/dataTable/index'
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';
import SearchSelect from '../../../core/common/search-select/searchSelect';
import CommonSelect2 from '../../../core/common/commonSelect2';


const PropertyList = () => {
    const [loading, setLoading] = useState(false);
    const routes = all_routes;
    const [allProperty, setAllProperty] = useState<any>([])
    const organizationId = localStorage.getItem("organization_id")
    const getAllProperty = async () => {
        const payload = {
            organization_id: organizationId
        }
        try {
            setLoading(true)
            const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.GET_ALL_PROPERTY, payload)
            console.log("property tttttttttt data ", response?.data)
            if (response?.success) {
                const result = response?.data
                setAllProperty(result)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllProperty();
    }, [])

    const columns = [
        // {
        //     title: "Sr No.",
        //     dataIndex: "SrNo",
        //     render: (text: string, record: any, index: number) => (
        //         <h6 className="fw-medium fs-14 text-dark" >{index + 1}</h6>
        //     ),
        //     sorter: false,
        // },
        // {
        //     title: "Nestfin ID",
        //     dataIndex: "nestfinid",
        //     render: (text: string, record: any,) => (
        //         <p className="text-capitalize" >{text}</p>
        //     ),
        //     sorter: (a: any, b: any) => (a.nestfinid || "").localeCompare(b.nestfinid || ""),
        // },
        {
            title: "Property Name",
            dataIndex: "property_name",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.property_name || "").localeCompare(b.property_name || ""),
        },
   {
  title: "Property Id",
  dataIndex: "property_id",
  render: (text: string, record: any) => (
    <p className="text-capitalize">{text ?? "-"}</p>
  ),
  sorter: (a: any, b: any) => (a.property_id || "").localeCompare(b.property_id || ""),
  width: 500,
},


        {
            title: "PinCode",
            dataIndex: "pincode",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.pincode || "").localeCompare(b.pincode || ""),
        },
        {
            title: "City",
            dataIndex: "city",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.city || "").localeCompare(b.city || ""),
        },
        {
            title: "State",
            dataIndex: "state",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.state || "").localeCompare(b.state || ""),
        },
        {
            title: "Locality",
            dataIndex: "locality",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.locality || "").localeCompare(b.locality || ""),
        },
        {
            title: "House Flat Block No",
            dataIndex: "house_flat_block_no",
            render: (text: string, record: any,) => (
                <p className="" >{text}</p>
            ),
            sorter: (a: any, b: any) => (a.house_flat_block_no || "").localeCompare(b.house_flat_block_no || ""),
        },
       {
  title: "Added On",
  dataIndex: "added_on",
  render: (text: string) => {
    if (!text) return "-";

    const date = new Date(text);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();

    return <p className="text-capitalize">{`${day}-${month}-${year}`}</p>;
  },
  sorter: (a: any, b: any) => {
    const dateA = new Date(a.added_on || 0).getTime();
    const dateB = new Date(b.added_on || 0).getTime();
    return dateA - dateB;
  },
},

        {
            title: "Total Units",
            dataIndex: "total_units",
            render: (text: string, record: any,) => (
                <p className="text-capitalize">{text}</p>
            ),
            sorter: (a: any, b: any) => Number(a.total_units || 0) - Number(b.total_units || 0),
        },
        {
            title: "Vacant Units",
            dataIndex: "vacant_units",
            render: (text: string, record: any,) => (
                <p className="text-capitalize">{text}</p>
            ),
            sorter: (a: any, b: any) => Number(a.vacant_units || 0) - Number(b.vacant_units || 0),
        },
       {
  title: "Status",
  dataIndex: "status",
  render: (text: string, record: any) => {
    const status = text?.toLowerCase();

    let textColor = "inherit";
    let backgroundColor = "transparent";

    switch (status) {
      case "active":
        textColor = "green";
        backgroundColor = "#e6f4ea"; // light green bg
        break;
      case "inactive":
        textColor = "red";
        backgroundColor = "#fdecea"; // light red bg
        break;
      case "available":
        textColor = "goldenrod";
        backgroundColor = "#fff8e1"; // light yellow bg
        break;
    }

    const formattedText = text
      ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      : "-";

    return (
      <span
        style={{
          color: textColor,
          backgroundColor,
          padding: "4px 8px",
          borderRadius: "6px",
          display: "inline-block",
          minWidth: "80px",
          textAlign: "center",
          textTransform: "capitalize",
        }}
      >
        {formattedText}
      </span>
    );
  },
  sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
}

    ];

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Property List </h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Property List
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                            {/* <Link to={routes.AllOrganizations}>
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-arrow-left me-2" />
                                    Back
                                </button>
                            </Link> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* <div className="col-md-12 mb-3 bg-white border p-3 shadow-sm rounded-3">
                        <label className='pb-2 fw-medium fs-15 d-block'>Select Organization:</label>
                        <CommonSelect2 className='d-inline ' options={options_organization} name='organization' defaultValue={orgId} onChange={(e: any) => setOrgId(e?.value)} styles={{ maxWidth: "500px" }} />
                        <button className='btn btn-primary px-3 ms-2' onClick={searchProperties}> <i className="bi bi-search me-sm-1"></i><span className='d-none d-sm-inline'>Search</span></button>
                    </div> */}

                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Property List </h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={allProperty} rowKeyId={"Staff_id"} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default PropertyList;